import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  InputAdornment,
  Divider,
  IconButton,
  useMediaQuery,
  useTheme,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  useOutletContext,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { developerTollApi } from "../../services/developerTollApi";
import Cookies from "js-cookie";
import AddCredits from "../AddCredits";
import axios from "axios";
import productsConfig from "../../config";
import Loader from "../Loader";
import { color } from "framer-motion";
import Login from "../../pages/Login/index2";
import SignInBox from "../../pages/SignIn";
import VerifySignupOTP from "../../pages/SignIn/SignupOtp";
import SignupDetails from "../../pages/SignIn/SignupDetails";
import ForgotPasswrod from "../../pages/Login/forgotPasswrod";
import NewPasswrod from "../../pages/Login/newPassword";
import RecoveryPassword from "../../pages/Login/recovery";
import useAuthModalsStore from "../../store/reducers/useAuthModalsStore";

const VisitAdmin = ({
  productData,
  header,
  setPremiumPopupOpen,
  selectedSubItem,
}) => {
  // const { open } = useOutletContext();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const { profileData } = useSelector((state) => state.profile);
  const [loader, setLoader] = useState(false);
  const signature = Cookies.get("c_d_token");
  const [allCredits, setAllCredits] = useState(0);
  const [companyFound, setCompanyFound] = useState(false);
  const [addCreditOpen, setAddCreditOpen] = useState(false);
  const [productConfig, setProductConfig] = useState({});
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const {
    loginOpen,
    setLoginOpen,
    forgotPasswordOpen,
    setForgotPasswordOpen,
    newPasswordOpen,
    setNewPasswordOpen,
    newRecoveryPasswordOpen,
    setNewRecoveryPasswordOpen,
    signInOpen,
    setSignInOpen,
    signInOtpOpen,
    setSignInOtpOpen,
    signInDetailsOpen,
    setSignInDetailsOpen,
    demoOpen,
    setDemoOpen,
  } = useAuthModalsStore();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  console.log();

  console.log(allCredits, productData, productConfig);

  useEffect(() => {
    const product = productsConfig.find(
      (p) =>
        p.productName.toLowerCase() === productData?.product_name.toLowerCase()
    );
    setProductConfig(product);
  }, [productsConfig, productData]);

  const handleVisitAdmin = async () => {
    if (signature) {
      if (
        productData?.sso_path &&
        productData?.sso_path?.toLowerCase() !== "none"
      ) {
        const payload = {
          sso_path: productData?.sso_path,
        };
        console.log(payload);
        setLoader(true);
        try {
          let response = await developerTollApi.visitAdminUrl(
            payload,
            signature
          );
          console.log(response);
          if (response?.status && response?.data) {
            setMenuAnchorEl(null);
            window.open(response.data, "_blank");
          }
        } catch (error) {
          console.error("Error fetching line chart data:", error);
        } finally {
          setLoader(false);
        }
      }
    } else {
      // navigate("/login", { state: { from: location } });
      setLoginOpen(true);
    }
  };

  const handleAddCredit = () => {
    if (signature) {
      setAddCreditOpen(true);
      setMenuAnchorEl(null);
    } else {
      // navigate("/login", { state: { from: location } });
      setLoginOpen(true);
    }
  };

  const getcredits = async () => {
    setAllCredits(0);
    try {
      const response = await axios.get(
        `${productConfig?.creditAPIUrl}/${profileData?.company_id}`
      );
      console.log(response);
      if (response?.data?.success == true) {
        setAllCredits(response?.data?.credits);
        setCompanyFound(true);
      } else {
        setCompanyFound(false);
      }
    } catch (error) {
      console.error(
        "getting credit error:",
        error.response?.data || error.message
      );
      return null;
    }
  };

  useEffect(() => {
    if (
      productConfig?.creditAPIUrl &&
      profileData?.company_id &&
      productData?.product_name &&
      productConfig?.productName?.toLowerCase() ===
        productData?.product_name?.toLowerCase()
    ) {
      getcredits();
    }
  }, [
    profileData?.company_id,
    productData?.product_name,
    productConfig?.productName,
    productConfig?.creditAPIUrl,
  ]);

  const handleMenuOpen = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };
  return (
    <>
      {!header ? (
        <>
          {isMobileOrTablet ? (
            <>
              <IconButton onClick={(e) => handleMenuOpen(e)}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="10.5"
                    y="3"
                    width="3"
                    height="3"
                    rx="1.5"
                    fill="#185CB7"
                    stroke="#185CB7"
                    stroke-width="1.5"
                  />
                  <rect
                    x="10.5"
                    y="10.5"
                    width="3"
                    height="3"
                    rx="1.5"
                    fill="#185CB7"
                    stroke="#185CB7"
                    stroke-width="1.5"
                  />
                  <rect
                    x="10.5"
                    y="18"
                    width="3"
                    height="3"
                    rx="1.5"
                    fill="#185CB7"
                    stroke="#185CB7"
                    stroke-width="1.5"
                  />
                </svg>
              </IconButton>
            </>
          ) : (
            <Box sx={{ display: "flex", gap: "16px" }}>
              {signature && companyFound && (
                <>
                  <Box
                    sx={{
                      minWidth: "168px",
                      height: 42,
                      color: "#ffffff",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      padding: "5px 5px 5px 10px",
                      borderRadius: "8px",
                      background: "#00B564",
                      textTransform: "none",
                      fontSize: "16px",
                      borderRadius: "10px",
                      border: "1px solid #00B564",
                      boxShadow: "none",
                      fontWeight: "500",
                      justifyContent: "space-between",
                    }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/images/credit.png`}
                      alt="Credit"
                      style={{ width: 21, height: 21 }}
                    />
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "16px",
                        color: "#FFFFFF",
                      }}
                    >
                      {JSON.stringify(allCredits) || 0} Credits
                    </Typography>
                    <IconButton
                      variant="contained"
                      sx={{
                        "&:disabled": {
                          background: "#E4E4E4",
                          color: "#ffffff",
                          borderColor: "#E4E4E4",
                        },
                        p: 0,
                      }}
                      onClick={handleAddCredit}
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="16"
                          cy="16"
                          r="16"
                          fill="white"
                          fill-opacity="0.16"
                        />
                        <path
                          d="M16 10V22M22 16H10"
                          stroke="white"
                          stroke-width="2.14286"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </IconButton>
                  </Box>
                </>
              )}
              <Button
                variant="contained"
                sx={{
                  width: "192px",
                  height: 42,
                  color: "#185CB7",
                  background: "#ffffff",
                  textTransform: "none",
                  fontSize: "16px",
                  borderRadius: "10px",
                  border: "1px solid #185CB7",
                  boxShadow: "none",
                  fontWeight: "600",
                  "&:hover": {
                    background: "#ffffff",
                    color: "#185CB7",
                    borderColor: "#185CB7",
                  },
                  gap: "13px",
                  whiteSpace: "nowrap",
                }}
                onClick={handleVisitAdmin}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 2C4.23858 2 2 4.23858 2 7C2 8.85071 3.0055 10.4666 4.5 11.3311V17.8431C4.5 18.6606 4.5 19.0694 4.65224 19.4369C4.80448 19.8045 5.09351 20.0935 5.67157 20.6716L7 22L9.10819 19.8918C9.20542 19.7946 9.25407 19.7459 9.2944 19.6932C9.40031 19.5547 9.46816 19.3909 9.49122 19.218C9.5 19.1522 9.5 19.0834 9.5 18.9459C9.5 18.8346 9.5 18.779 9.4941 18.7249C9.47864 18.5831 9.43303 18.4463 9.36035 18.3236C9.33263 18.2768 9.29924 18.2323 9.23246 18.1433L8 16.5L8.7 15.5667C9.09649 15.038 9.29473 14.7737 9.39737 14.4658C9.5 14.1579 9.5 13.8275 9.5 13.1667V11.3311C10.9945 10.4666 12 8.85071 12 7C12 4.23858 9.76142 2 7 2Z"
                    stroke="#185CB7"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 7H7.00898"
                    stroke="#185CB7"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13 14H19C19.9319 14 20.3978 14 20.7654 14.1522C21.2554 14.3552 21.6448 14.7446 21.8478 15.2346C22 15.6022 22 16.0681 22 17C22 17.9319 22 18.3978 21.8478 18.7654C21.6448 19.2554 21.2554 19.6448 20.7654 19.8478C20.3978 20 19.9319 20 19 20H13"
                    stroke="#185CB7"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M15 5H19C19.9319 5 20.3978 5 20.7654 5.15224C21.2554 5.35523 21.6448 5.74458 21.8478 6.23463C22 6.60218 22 7.06812 22 8C22 8.93188 22 9.39782 21.8478 9.76537C21.6448 10.2554 21.2554 10.6448 20.7654 10.8478C20.3978 11 19.9319 11 19 11H15"
                    stroke="#185CB7"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </svg>
                My Credentials
              </Button>
            </Box>
          )}
        </>
      ) : (
        <>
          {isMobileOrTablet && (
            <Button
              variant="contained"
              sx={{
                height: 42,
                color: "#000000",
                background: "none",
                textTransform: "none",
                fontSize: "16px",
                borderRadius: "10px",
                border: "none",
                boxShadow: "none",
                fontWeight: "500",
                gap: "4px",
                p: 0,
                minWidth: 0,
              }}
              onClick={() => setPremiumPopupOpen(true)}
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.98851 15.2948L4.63119 16.139H4.63119L4.98851 15.2948ZM4.98851 8.53853L5.34584 9.38269L4.98851 8.53853ZM5.67397 8.41743L5.5 9.31743L5.67397 8.41743ZM6.261 8.8064L7.022 8.29536L6.261 8.8064ZM5.67397 15.4159L5.5 14.5159H5.5L5.67397 15.4159ZM6.261 15.0269L5.5 14.5159L5.5 14.5159L6.261 15.0269ZM17.0115 15.2948L17.3688 16.139L17.0115 15.2948ZM17.0115 8.53853L16.6542 9.38269L17.0115 8.53853ZM16.326 8.41743L16.5 9.31743L16.326 8.41743ZM15.739 8.8064L14.978 8.29536H14.978L15.739 8.8064ZM16.326 15.4159L16.5 14.5159H16.5L16.326 15.4159ZM15.739 15.0269L16.5 14.5159V14.5159L15.739 15.0269ZM18.3333 15.5833C18.3333 15.0771 17.9229 14.6667 17.4167 14.6667C16.9104 14.6667 16.5 15.0771 16.5 15.5833H17.4167H18.3333ZM11 17.4167C10.4937 17.4167 10.0833 17.8271 10.0833 18.3333C10.0833 18.8396 10.4937 19.25 11 19.25V18.3333V17.4167ZM4.98851 15.2948L5.34583 14.4506C4.35736 14.0322 3.66667 13.0541 3.66667 11.9167H2.75H1.83333C1.83333 13.8161 2.9886 15.4437 4.63119 16.139L4.98851 15.2948ZM2.75 11.9167H3.66667C3.66667 10.7793 4.35736 9.8011 5.34584 9.38269L4.98851 8.53853L4.63119 7.69438C2.9886 8.38967 1.83333 10.0172 1.83333 11.9167H2.75ZM6.41667 14.1167H7.33333V9.71667H6.41667H5.5V14.1167H6.41667ZM4.98851 8.53853L5.34584 9.38269C5.41901 9.35172 5.46058 9.33428 5.49526 9.32125C5.52659 9.30947 5.53308 9.30878 5.52632 9.31026C5.51607 9.31249 5.50097 9.31438 5.48651 9.31433C5.47428 9.31429 5.47623 9.31284 5.5 9.31743L5.67397 8.41743L5.84794 7.51742C5.60828 7.47109 5.37843 7.46616 5.1362 7.51891C4.9328 7.56321 4.74535 7.64606 4.63119 7.69438L4.98851 8.53853ZM6.41667 9.71667H7.33333C7.33333 9.3386 7.36261 8.80257 7.022 8.29536L6.261 8.8064L5.5 9.31743C5.50007 9.31754 5.49822 9.31477 5.49555 9.30952C5.49283 9.30418 5.49036 9.29845 5.48842 9.29304C5.4843 9.28159 5.48603 9.28138 5.48902 9.30325C5.49241 9.32797 5.49593 9.36913 5.49791 9.44142C5.49993 9.5147 5.5 9.60002 5.5 9.71667H6.41667ZM5.67397 8.41743L5.5 9.31743C5.48628 9.31478 5.47543 9.31208 5.46767 9.30995C5.45985 9.3078 5.45413 9.30594 5.45061 9.30472C5.44394 9.30243 5.44258 9.30156 5.44642 9.30333C5.45002 9.30499 5.45631 9.30811 5.46479 9.31289C5.47319 9.31762 5.48243 9.32325 5.49196 9.32957C5.50149 9.33588 5.51028 9.3422 5.51791 9.34809C5.52562 9.35404 5.53094 9.35861 5.53387 9.36128C5.537 9.36413 5.53567 9.3632 5.53096 9.35796C5.52847 9.35519 5.52453 9.35065 5.5195 9.34429C5.51451 9.33798 5.50779 9.32903 5.5 9.31743L6.261 8.8064L7.022 8.29536C6.87319 8.07376 6.66348 7.90655 6.50462 7.80128C6.34575 7.69602 6.11002 7.56808 5.84794 7.51742L5.67397 8.41743ZM4.98851 15.2948L4.63119 16.139C4.74535 16.1873 4.9328 16.2701 5.1362 16.3144C5.37843 16.3672 5.60828 16.3622 5.84794 16.3159L5.67397 15.4159L5.5 14.5159C5.47623 14.5205 5.47428 14.519 5.48651 14.519C5.50097 14.5189 5.51607 14.5208 5.52632 14.5231C5.53308 14.5245 5.52659 14.5239 5.49526 14.5121C5.46058 14.499 5.41901 14.4816 5.34583 14.4506L4.98851 15.2948ZM6.41667 14.1167H5.5C5.5 14.2333 5.49993 14.3186 5.49791 14.3919C5.49593 14.4642 5.49241 14.5054 5.48902 14.5301C5.48603 14.552 5.4843 14.5517 5.48842 14.5403C5.49036 14.5349 5.49283 14.5291 5.49555 14.5238C5.49822 14.5186 5.50007 14.5158 5.5 14.5159L6.261 15.0269L7.022 15.538C7.36261 15.0308 7.33333 14.4947 7.33333 14.1167H6.41667ZM5.67397 15.4159L5.84794 16.3159C6.11002 16.2653 6.34575 16.1373 6.50462 16.032C6.66348 15.9268 6.87319 15.7596 7.022 15.538L6.261 15.0269L5.5 14.5159C5.50779 14.5043 5.51451 14.4954 5.5195 14.489C5.52453 14.4827 5.52847 14.4781 5.53096 14.4754C5.53567 14.4701 5.537 14.4692 5.53387 14.472C5.53094 14.4747 5.52562 14.4793 5.51791 14.4852C5.51028 14.4911 5.50149 14.4975 5.49196 14.5038C5.48243 14.5101 5.47319 14.5157 5.46479 14.5204C5.45631 14.5252 5.45002 14.5283 5.44642 14.53C5.44258 14.5318 5.44394 14.5309 5.45061 14.5286C5.45413 14.5274 5.45985 14.5255 5.46767 14.5234C5.47543 14.5213 5.48628 14.5185 5.5 14.5159L5.67397 15.4159ZM17.0115 15.2948L17.3688 16.139C19.0114 15.4437 20.1667 13.8161 20.1667 11.9167H19.25H18.3333C18.3333 13.0541 17.6426 14.0322 16.6542 14.4506L17.0115 15.2948ZM19.25 11.9167H20.1667C20.1667 10.0172 19.0114 8.38967 17.3688 7.69438L17.0115 8.53853L16.6542 9.38269C17.6426 9.8011 18.3333 10.7793 18.3333 11.9167H19.25ZM15.5833 14.1167H16.5V9.71667H15.5833H14.6667V14.1167H15.5833ZM17.0115 8.53853L17.3688 7.69438C17.2547 7.64606 17.0672 7.56321 16.8638 7.51891C16.6216 7.46616 16.3917 7.47109 16.1521 7.51742L16.326 8.41743L16.5 9.31743C16.5238 9.31284 16.5257 9.31429 16.5135 9.31433C16.499 9.31438 16.4839 9.31249 16.4737 9.31026C16.4669 9.30878 16.4734 9.30947 16.5047 9.32125C16.5394 9.33428 16.581 9.35172 16.6542 9.38269L17.0115 8.53853ZM15.5833 9.71667H16.5C16.5 9.60002 16.5001 9.5147 16.5021 9.44142C16.5041 9.36913 16.5076 9.32797 16.511 9.30325C16.514 9.28138 16.5157 9.28159 16.5116 9.29304C16.5096 9.29845 16.5072 9.30418 16.5045 9.30952C16.5018 9.31477 16.4999 9.31754 16.5 9.31743L15.739 8.8064L14.978 8.29536C14.6374 8.80257 14.6667 9.3386 14.6667 9.71667H15.5833ZM16.326 8.41743L16.1521 7.51742C15.89 7.56808 15.6542 7.69602 15.4954 7.80128C15.3365 7.90655 15.1268 8.07376 14.978 8.29536L15.739 8.8064L16.5 9.31743C16.4922 9.32903 16.4855 9.33798 16.4805 9.34429C16.4755 9.35065 16.4715 9.35519 16.469 9.35796C16.4643 9.36321 16.463 9.36413 16.4661 9.36128C16.4691 9.35861 16.4744 9.35404 16.4821 9.34809C16.4897 9.3422 16.4985 9.33588 16.508 9.32957C16.5176 9.32325 16.5268 9.31762 16.5352 9.31289C16.5437 9.30811 16.55 9.30499 16.5536 9.30333C16.5574 9.30156 16.5561 9.30243 16.5494 9.30472C16.5459 9.30594 16.5402 9.3078 16.5323 9.30995C16.5246 9.31208 16.5137 9.31478 16.5 9.31743L16.326 8.41743ZM17.0115 15.2948L16.6542 14.4506C16.581 14.4816 16.5394 14.499 16.5047 14.5121C16.4734 14.5239 16.4669 14.5245 16.4737 14.5231C16.4839 14.5208 16.499 14.5189 16.5135 14.519C16.5257 14.519 16.5238 14.5205 16.5 14.5159L16.326 15.4159L16.1521 16.3159C16.3917 16.3622 16.6216 16.3672 16.8638 16.3144C17.0672 16.2701 17.2547 16.1873 17.3688 16.139L17.0115 15.2948ZM15.5833 14.1167H14.6667C14.6667 14.4947 14.6374 15.0308 14.978 15.538L15.739 15.0269L16.5 14.5159C16.4999 14.5158 16.5018 14.5186 16.5045 14.5238C16.5072 14.5291 16.5096 14.5349 16.5116 14.5403C16.5157 14.5517 16.514 14.552 16.511 14.5301C16.5076 14.5054 16.5041 14.4642 16.5021 14.3919C16.5001 14.3186 16.5 14.2333 16.5 14.1167H15.5833ZM16.326 15.4159L16.5 14.5159C16.5137 14.5185 16.5246 14.5213 16.5323 14.5234C16.5402 14.5255 16.5459 14.5274 16.5494 14.5286C16.5561 14.5309 16.5574 14.5318 16.5536 14.53C16.55 14.5283 16.5437 14.5252 16.5352 14.5204C16.5268 14.5157 16.5176 14.5101 16.508 14.5038C16.4985 14.4975 16.4897 14.4911 16.4821 14.4852C16.4744 14.4793 16.4691 14.4747 16.4661 14.472C16.463 14.4692 16.4643 14.4701 16.469 14.4754C16.4715 14.4781 16.4755 14.4827 16.4805 14.489C16.4855 14.4954 16.4922 14.5043 16.5 14.5159L15.739 15.0269L14.978 15.538C15.1268 15.7596 15.3365 15.9268 15.4954 16.032C15.6542 16.1373 15.89 16.2653 16.1521 16.3159L16.326 15.4159ZM4.58333 9.16667H5.5C5.5 6.1291 7.96243 3.66667 11 3.66667V2.75V1.83333C6.94991 1.83333 3.66667 5.11658 3.66667 9.16667H4.58333ZM11 2.75V3.66667C14.0376 3.66667 16.5 6.1291 16.5 9.16667H17.4167H18.3333C18.3333 5.11658 15.0501 1.83333 11 1.83333V2.75ZM17.4167 15.5833H16.5V16.5H17.4167H18.3333V15.5833H17.4167ZM15.5833 18.3333V17.4167H11V18.3333V19.25H15.5833V18.3333ZM17.4167 16.5H16.5C16.5 17.0063 16.0896 17.4167 15.5833 17.4167V18.3333V19.25C17.1021 19.25 18.3333 18.0188 18.3333 16.5H17.4167Z"
                  fill="#D50B34"
                />
              </svg>
            </Button>
          )}
          <Button
            variant="contained"
            onClick={() => {
              setLoginOpen(true);
            }}
            sx={{
              color: "#fff",
              background: "#185CB7",
              textTransform: "none",
              "&:hover": { background: "#185CB7" },
              padding: "5px 35px",
              borderRadius: "8px",
              fontSize: isSmallScreen ? "15px" : "16px",
              fontWeight: "600",
            }}
          >
            Login
          </Button>{" "}
        </>
      )}
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            minHeight: "123px",
            width: "150px",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            overflow: "hidden",
            alignItems: "center",
            p: 0,
            "& .MuiList-root": { padding: 0 },
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          sx={{
            fontSize: "14px",
            fontWeight: "500",
            color: "#1D1D1D",
            gap: 1,
            background: "#FFF5E9",
            minHeight: 33,
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/credit.png`}
            alt="Credit"
            style={{ width: 16, height: 16 }}
          />
          <Typography
            sx={{ fontWeight: 500, fontSize: "16px", color: "#000000" }}
          >
            {allCredits || 0} Credits
          </Typography>
        </MenuItem>
        <Divider sx={{ borderColor: "#FFEDD9", m: "0 !important" }} />
        <MenuItem
          sx={{ fontSize: "14px", fontWeight: "400", color: "#5C5C5C", gap: 1 }}
          onClick={() => handleAddCredit}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_734_418)">
              <path
                d="M9 6V12M12 9H6"
                stroke="#1D1D1D"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <circle
                cx="9"
                cy="9"
                r="7.5"
                stroke="#1D1D1D"
                stroke-width="1.5"
              />
            </g>
            <defs>
              <clipPath id="clip0_734_418">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>
          Add Credits
        </MenuItem>
        <Divider
          sx={{
            borderColor: "#DDDDDD",
            m: "0 !important",
            width: "70%",
            ml: "auto !important",
          }}
        />
        <MenuItem
          sx={{ fontSize: "14px", fontWeight: "400", color: "#5C5C5C", gap: 1 }}
          onClick={handleVisitAdmin}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 2C4.23858 2 2 4.23858 2 7C2 8.85071 3.0055 10.4666 4.5 11.3311V17.8431C4.5 18.6606 4.5 19.0694 4.65224 19.4369C4.80448 19.8045 5.09351 20.0935 5.67157 20.6716L7 22L9.10819 19.8918C9.20542 19.7946 9.25407 19.7459 9.2944 19.6932C9.40031 19.5547 9.46816 19.3909 9.49122 19.218C9.5 19.1522 9.5 19.0834 9.5 18.9459C9.5 18.8346 9.5 18.779 9.4941 18.7249C9.47864 18.5831 9.43303 18.4463 9.36035 18.3236C9.33263 18.2768 9.29924 18.2323 9.23246 18.1433L8 16.5L8.7 15.5667C9.09649 15.038 9.29473 14.7737 9.39737 14.4658C9.5 14.1579 9.5 13.8275 9.5 13.1667V11.3311C10.9945 10.4666 12 8.85071 12 7C12 4.23858 9.76142 2 7 2Z"
              stroke="#1D1D1D"
              stroke-width="1.5"
              stroke-linejoin="round"
            />
            <path
              d="M7 7H7.00898"
              stroke="#1D1D1D"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13 14H19C19.9319 14 20.3978 14 20.7654 14.1522C21.2554 14.3552 21.6448 14.7446 21.8478 15.2346C22 15.6022 22 16.0681 22 17C22 17.9319 22 18.3978 21.8478 18.7654C21.6448 19.2554 21.2554 19.6448 20.7654 19.8478C20.3978 20 19.9319 20 19 20H13"
              stroke="#1D1D1D"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M15 5H19C19.9319 5 20.3978 5 20.7654 5.15224C21.2554 5.35523 21.6448 5.74458 21.8478 6.23463C22 6.60218 22 7.06812 22 8C22 8.93188 22 9.39782 21.8478 9.76537C21.6448 10.2554 21.2554 10.6448 20.7654 10.8478C20.3978 11 19.9319 11 19 11H15"
              stroke="#1D1D1D"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
          My Credentials
        </MenuItem>
        {selectedSubItem?.demo_url && (
          <>
            <Divider
              sx={{
                borderColor: "#DDDDDD",
                m: "0 !important",
                width: "70%",
                ml: "auto !important",
              }}
            />
            <MenuItem
              sx={{
                fontSize: "14px",
                fontWeight: "400",
                color: "#5C5C5C",
                gap: 1,
              }}
              onClick={() => {
                setDemoOpen(true);
                setMenuAnchorEl(null);
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_3000_11689)">
                  <circle
                    cx="9.99935"
                    cy="9.99935"
                    r="8.33333"
                    stroke="#1D1D1D"
                    stroke-width="1.5"
                  />
                  <path
                    d="M12.8447 9.11688C13.4962 9.50151 13.4962 10.4972 12.8447 10.8818L8.91124 13.2042C8.27809 13.578 7.5 13.0915 7.5 12.3217L7.5 7.67698C7.5 6.90724 8.27809 6.42069 8.91124 6.79451L12.8447 9.11688Z"
                    fill="#1D1D1D"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3000_11689">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Play Demo
            </MenuItem>
          </>
        )}
      </Menu>

      <AddCredits
        addCreditOpen={addCreditOpen}
        setAddCreditOpen={setAddCreditOpen}
        loader={loader}
        setLoader={setLoader}
        productData={productData}
        getcredits={getcredits}
        allCredits={allCredits}
      />
      {loader && <Loader />}

      {loginOpen && (
        <Login
          setLoginOpen={setLoginOpen}
          loginOpen={loginOpen}
          setSignInOpen={setSignInOpen}
          setForgotPasswordOpen={setForgotPasswordOpen}
        />
      )}

      {forgotPasswordOpen && (
        <ForgotPasswrod
          forgotPasswordOpen={forgotPasswordOpen}
          setForgotPasswordOpen={setForgotPasswordOpen}
          setNewPasswordOpen={setNewPasswordOpen}
          setLoginOpen={setLoginOpen}
        />
      )}

      {newPasswordOpen && (
        <NewPasswrod
          newPasswordOpen={newPasswordOpen}
          setNewPasswordOpen={setNewPasswordOpen}
          setLoginOpen={setLoginOpen}
          setNewRecoveryPasswordOpen={setNewRecoveryPasswordOpen}
        />
      )}

      {newRecoveryPasswordOpen && (
        <RecoveryPassword
          newRecoveryPasswordOpen={newRecoveryPasswordOpen}
          setNewRecoveryPasswordOpen={setNewRecoveryPasswordOpen}
          setLoginOpen={setLoginOpen}
        />
      )}

      {signInOpen && (
        <SignInBox
          signInOpen={signInOpen}
          setSignInOpen={setSignInOpen}
          setSignInOtpOpen={setSignInOtpOpen}
          setLoginOpen={setLoginOpen}
        />
      )}

      {signInOtpOpen && (
        <VerifySignupOTP
          signInOtpOpen={signInOtpOpen}
          setSignInOtpOpen={setSignInOtpOpen}
          setSignInDetailsOpen={setSignInDetailsOpen}
          setLoginOpen={setLoginOpen}
        />
      )}

      {signInDetailsOpen && (
        <SignupDetails
          signInDetailsOpen={signInDetailsOpen}
          setSignInDetailsOpen={setSignInDetailsOpen}
          setLoginOpen={setLoginOpen}
        />
      )}
    </>
  );
};

export default VisitAdmin;
